/** Shared router/URL boundary: TanStack may parse repeated values as arrays. */
export function analyticsSearch(
  search: Record<string, unknown>,
): Record<string, string | string[]> {
  const out: Record<string, string | string[]> = {};
  const keys = new Set([
    "q",
    "artifact",
    "where",
    "scope",
    "fallback",
    "range",
    "since",
    "until",
    "time_field",
    "min_confidence",
    "definition_scope",
    "chain_id",
    "is_highlight",
    "case",
  ]);
  for (const [key, value] of Object.entries(search)) {
    if (!keys.has(key) && !key.startsWith("var_")) continue;
    if (key === "artifact" && value && typeof value === "object" && !Array.isArray(value)) {
      out[key] = JSON.stringify(value);
      continue;
    }
    if (Array.isArray(value))
      out[key] = value.filter((v) => typeof v === "string");
    else if (
      typeof value === "string" ||
      typeof value === "number" ||
      typeof value === "boolean"
    )
      out[key] = String(value);
  }
  return out;
}
export function searchParamsOf(
  search: Record<string, unknown>,
): URLSearchParams {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(analyticsSearch(search))) {
    for (const item of Array.isArray(value) ? value : [value])
      params.append(key, item);
  }
  return params;
}
export function searchRecordOf(
  params: URLSearchParams,
): Record<string, string | string[]> {
  const out: Record<string, string | string[]> = {};
  for (const key of new Set(params.keys())) {
    const values = params.getAll(key);
    out[key] = values.length === 1 ? values[0]! : values;
  }
  return out;
}
